import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EuiTableSelectableRowService } from '../services/eui-table-selectable-row.service';

@Component({
    // tslint:disable-next-line
    selector: 'tr[isSelectableHeader]',
    templateUrl: './eui-table-selectable-header.component.html',
})

export class EuiTableSelectableHeaderComponent implements OnInit, OnDestroy {

    @Input() isSelectableHeader: any;
    @Input() isChecked = false;

    @ViewChild('checkbox') checkbox: ElementRef<HTMLInputElement>;

    public isCheckedIndeterminate = false;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private euiTableSelectableRowService: EuiTableSelectableRowService) {}

    ngOnInit() {
        this.euiTableSelectableRowService.isAllRowsSelected$.pipe(takeUntil(this.destroy$)).subscribe((selected) => {
            setTimeout(() => {
                this.isChecked = selected;
                if (this.checkbox) {
                    this.checkbox.nativeElement.checked = selected;
                }

                if (!selected && this.euiTableSelectableRowService.selectedRows$.value.length > 0) {
                    this.isCheckedIndeterminate = true;
                } else {
                    this.isCheckedIndeterminate = false;
                }
            });
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    public toggleCheckedState(value: boolean) {
        this.isChecked = value;

        if (this.isChecked) {
            this.euiTableSelectableRowService.selectAllRows();
        } else {
            this.euiTableSelectableRowService.unselectAllRows();
        }
    }
}
